import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import compose from '../../hoc/compose';
import * as colorUtil from '../../util/color';
import { getRectByReactElement } from '../../util/rect';
import template from './colorSpace.jsx';
import displayNames from '../displayNames';
var hsbToStyle = function hsbToStyle(hsb) {
  return {
    left: "".concat(hsb.saturation, "%"),
    bottom: "calc(".concat(hsb.brightness, "% - 10px)"),
    borderColor: hsb.brightness > 60 ? '#000' : '#FFF'
  };
};
var isCloseOrEqual = function isCloseOrEqual(a, b) {
  return Math.abs(b - a) <= 5;
};
var ColorSpace = /*#__PURE__*/function (_React$Component) {
  function ColorSpace(props) {
    var _this;
    _classCallCheck(this, ColorSpace);
    _this = _callSuper(this, ColorSpace, [props]);
    _this.state = {
      hsb: colorUtil.hexToHsb(_this.props.value)
    };
    _this.getMarkerPosition = function () {
      return hsbToStyle(_this.state.hsb);
    };
    var ensureWithinLimits = function ensureWithinLimits(n) {
      return Math.min(Math.max(0, n), 100);
    };
    var getHsbColorByMouseEvent = function getHsbColorByMouseEvent(e) {
      var x = e.clientX - _this.gradientRect.x;
      var y = e.clientY - _this.gradientRect.y;
      var saturation = ensureWithinLimits(100 * x / _this.gradientRect.width);
      var brightness = ensureWithinLimits(100 - 100 * y / _this.gradientRect.height);
      var hue = _this.state.hsb.hue;
      return {
        brightness: brightness,
        saturation: saturation,
        hue: hue
      };
    };
    _this.setNewColorByMouseEvent = function (e) {
      var hsb = getHsbColorByMouseEvent(e);
      var newColor = colorUtil.hsbToHex(hsb);
      if (hsb.brightness < 5) {
        _this.setState({
          hsb: hsb
        }, function () {
          _this.props.onChange(newColor);
        });
      } else {
        _this.props.onChange(newColor);
      }
    };
    _this.onMarkerDragStart = function (e) {
      window.addEventListener('mousemove', _this.onMarkerDrag);
      window.addEventListener('mouseup', _this.onMarkerDragEnd);
      _this.gradientRect = getRectByReactElement(_this.refs.gradient);
      _this.setNewColorByMouseEvent(e);
    };
    _this.onMarkerDrag = function (e) {
      _this.setNewColorByMouseEvent(e);
    };
    _this.onMarkerDragEnd = function () {
      window.removeEventListener('mousemove', _this.onMarkerDrag);
      window.removeEventListener('mouseup', _this.onMarkerDragEnd);
    };
    _this.setNewColorByHue = function (hue) {
      return _({
        hue: hue
      }).defaults(_this.state.hsb).thru(colorUtil.hsbToHex).thru(function (hex) {
        _this.setState({
          hsb: _.defaults({
            hue: hue
          }, _this.state.hsb)
        }, function () {
          _this.props.onChange(hex);
        });
      }).value();
    };
    _this.getBrightnessOptions = function () {
      return _(5).times(function () {
        return _this.state.hsb;
      }).map(function (color, i) {
        return colorUtil.hsbToHex({
          hue: _this.state.hsb.hue,
          saturation: color.saturation,
          brightness: i * 20 + 10
        });
      }).reverse();
    };
    _this.setNewColorByHex = function (hex) {
      return _this.props.onChange(hex);
    };
    return _this;
  }
  _inherits(ColorSpace, _React$Component);
  return _createClass(ColorSpace, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var hsb = colorUtil.hexToHsb(nextProps.value);
      var shouldKeepHue = hsb.saturation < 5 || hsb.brightness < 5 || isCloseOrEqual(hsb.hue % 358, this.state.hsb.hue % 358);
      var shouldKeepSaturation = hsb.brightness < 5;
      this.setState({
        hsb: _.defaults({
          hue: shouldKeepHue ? this.state.hsb.hue : hsb.hue,
          saturation: shouldKeepSaturation ? this.state.hsb.saturation : hsb.saturation
        }, hsb)
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('mousemove', this.onMarkerDrag);
      window.removeEventListener('mouseup', this.onMarkerDragEnd);
    }
  }, {
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);
}(React.Component);
ColorSpace.displayName = displayNames.COLOR_SPACE;
ColorSpace.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** The current color value in HEX, for example `#FB2D5G` */
  value: PropTypes.string.isRequired,
  /** Invoked on change of color. Parameter: `color` - the new selected color in HEX {string} */
  onChange: PropTypes.func.isRequired
};
ColorSpace.defaultProps = {};
export default compose(ColorSpace);